import type { GTMEcommerceReturnType, GTMItemData, GTMItemsReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';
import { calculateValue, useFallbackForEmptyCategories } from '../GTMHelpers';

interface GTMViewItemEcommerceReturnType {
    value: number;
    items: Omit<GTMItemsReturnType, 'index'>[];
}

export default class GTMViewItemModel extends GTMBaseModel {
    public static parseToGTMData({
        id,
        title,
        country,
        region,
        department,
        place,
        discount,
        pricePerNight,
        instantBooking,
        quantity = 1
    }: GTMItemData): GTMEcommerceReturnType<GTMViewItemEcommerceReturnType> {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'view_item',
            ecommerce: {
                value: calculateValue(pricePerNight, quantity),
                items: [
                    {
                        item_id: id,
                        item_name: title,
                        ...useFallbackForEmptyCategories({
                            country,
                            region,
                            department,
                            place
                        }),
                        discount,
                        quantity,
                        price: pricePerNight,
                        instant_booking: instantBooking
                    }
                ]
            }
        };
    }
}
